import type { StationRepository } from "@station/domain/repositories/station.repository";
import { stationsTypes } from "@station/station-types.di.ts";
import { inject, injectable } from "inversify";

@injectable()
export class StationRemoveAllSelectedUseCase {
    constructor(
        @inject(stationsTypes.repositories.StationRepository)
        private readonly stationRepository: StationRepository,
    ) {}

    execute(): void {
        this.stationRepository.removeAllStations();
    }
}
